import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  TPersonalDataWhyApplicationsFormRequest,
  TPersonalDataWhyApplicationsFormResponse,
} from '~/store/processing-personal/types.ts';
import api from '~/libs/api';
import { thunkErrorHandler } from '~/store/utils.ts';

export const whyRevokeApplicationForm = createAsyncThunk<
  TPersonalDataWhyApplicationsFormResponse,
  TPersonalDataWhyApplicationsFormRequest
>('processingPersonal/whyRevokeApplicationForm', async ({ appId, data }, { rejectWithValue }) => {
  try {
    const response = await api.patch(
      `/personal-data/public/personal-data/applications/${appId}/deny`,
      data
    );
    return response.data;
  } catch (error) {
    return thunkErrorHandler(error, rejectWithValue);
  }
});
